import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../../services/authentication.service';
import { MenuItem } from '../../../Models/menuItem';
import { Router } from '@angular/router';
import { menuComponentFromTo } from '../../../Models/menuComponentFromTo';
import {MasterPageComponent} from '../../masterpage.component';
declare const $;
window['$'] = window['jQuery'] = $;

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})

export class NavMenuComponent implements OnInit {

  menuItems$: Observable<MenuItem[]>;

  isLoggedIn$: Observable<boolean>;

  menu: MenuItem[];
  collapsedLogo: string;
  extendedLogo: string;
  brandLink: string;

  constructor(private authenticationService: AuthenticationService, private router: Router, private master: MasterPageComponent) {

  }

  ngOnInit() {
    this.extendedLogo = localStorage.getItem('extendedLogo');
    this.collapsedLogo = localStorage.getItem('collapsedLogo');
    this.brandLink = localStorage.getItem('favPage') ? localStorage.getItem('favPage') : '/home';
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
    this.menuItems$ = this.authenticationService.getMenus;
    this.menuItems$.subscribe( result => {
      if (result != null) {
        localStorage.setItem('navMenu', JSON.stringify(result));
      }
      this.menu = JSON.parse(localStorage.getItem('navMenu'));
    });
    if (document.body.classList.contains('sidebar-collapse')) {
      document.getElementById('horizontal-brand').hidden = true;
      document.getElementById('rounded-brand').hidden = false;
    } else {
      document.getElementById('horizontal-brand').hidden = false;
      document.getElementById('rounded-brand').hidden = true;
    }

  }

  collapse() {
    document.body.classList.add('sidebar-collapse');
    document.body.classList.remove('sidebar-open');
    document.getElementById('horizontal-brand').hidden = true;
    document.getElementById('rounded-brand').hidden = false;
   }

  changeBrand(event: string) {

    if (document.body.classList.contains('sidebar-collapse')) {
      if (event === 'over') {
        document.getElementById('horizontal-brand').hidden = false;
        document.getElementById('rounded-brand').hidden = true;
        const firstSelectElement = $('form:first select:first');
        if (firstSelectElement.length > 0) {
          $('form:first select:first').blur();
        }

        if (document.getElementsByClassName('ng-dropdown-panel').length > 0) {
          let d = <HTMLElement>(document.getElementsByClassName('ng-dropdown-panel')[0]);
          d.style.zIndex = '1030';
        }
      } else {
        document.getElementById('horizontal-brand').hidden = true;
        document.getElementById('rounded-brand').hidden = false;

        this.master.closeSideBarDropDown();
      }
    }
  }

  getLIClass(menuItem: MenuItem) {
    return `nav-item nav-menu-items ${!menuItem.parentId ? 'liParent' : 'liChild'}`;
  }

  getIconClass(menuItem: MenuItem) {
    let cls = 'nav-icon fa';
    if (!menuItem.parentId) {
      cls += ' ' + menuItem.itemIcon;
    } else if ( menuItem.parentId && menuItem.children && menuItem.children.length > 0 ) {
      cls += 's fa-circle';
    } else {
      cls += 'r fa-circle';
    }
    return cls;
  }

  expandDropDown(event) {
    // necessário para que o evento click não seja executado novamente no menu "pai", caso haja.
    event.preventDefault();
    event.stopPropagation();

    // verificar se existe a classe. se não, adicioná-las
    const target = event.currentTarget.classList;
    const targetId = event.currentTarget.id;
    const targetParentElement = event.currentTarget.parentNode.parentNode;

    if (!(target.contains('menu-is-opening') || target.contains('menu-open'))) {
      target.add('menu-is-opening', 'menu-open');

      const navItems = document.querySelectorAll('.nav-menu-items');
      navItems.forEach(function(q) {
        // remover as classes dos demais itens

        const item = document.getElementById(q.id);
        // verificar se item é o pai do menu que está aberto, caso seja, não poderá remover a classe
        if (targetParentElement !== item && item.classList.contains('menu-is-opening')) {
          if (q.id !== targetId) {
            item.classList.remove('menu-is-opening', 'menu-open');
          }
        }
      });
    } else {
      target.remove('menu-is-opening', 'menu-open');
    }

  }

  getUrl(url: string) {
    const menu = menuComponentFromTo.find(e => e.urlMenu === url);
    return menu ? menu.routeMenu : '';
  }

  getElementId(menuItem: MenuItem) {
    let id = menuItem.name;
    if (!menuItem.parentId) {
      id += 'Parent'; // ' ' + menuItem.name;
    }
    return id.normalize('NFD').replace(/[\u0300-\u036f( )+]/g, '');
  }

  onLogout() {
    this.authenticationService.logout();
  }

}
